/**
 * `@ocap/client/subscribe` — optional subscribe/unsubscribe installer.
 *
 * The default `@ocap/client` browser entry drops `@arcblock/ws` (phoenix +
 * `ws`) from the bundle. Consumers that need topic subscriptions in the
 * browser must explicitly install this module; Node/legacy entries install
 * it automatically from their constructors.
 *
 *   const { install } = require('@ocap/client/subscribe');
 *   install(client); // overrides the default `throw` stubs
 *   client.subscribe(topic, callback);
 */
const { WsClient } = require('@arcblock/ws');

function install(client) {
  const ensureSocketClient = () => {
    if (!client._socketClient) {
      client._socketClient = new WsClient(
        client.config.socketEndpoint(),
        Object.assign(client._getSocketOptions(), {
          heartbeatIntervalMs: 10 * 1000,
        })
      );
    }

    if (client._socketClient.isConnected() === false) {
      client._socketClient.connect();
    }

    return client._socketClient;
  };

  client._ensureSocketClient = ensureSocketClient;
  client.subscribe = (topic, callback) => ensureSocketClient().on(topic, callback);
  client.unsubscribe = (topic, callback) => ensureSocketClient().off(topic, callback);

  return client;
}

module.exports = { install };
